var modules_a1e6048f = {"collapse-overflow":"_1jtc14t","collapse-visible":"_1yy6g7r","collapse-hidden":"_6nxk7o"};
import "../../../assets/D9cQCL2H.css";

export { modules_a1e6048f as default };
//# sourceMappingURL=Transition.module.less.js.map
